<template>
  <div>
    <page-header :title="$t('bill.analysis_cost_alarm')" />
    <page-body>
      <analysis-alarm-list id="AnalysisAlarmList" />
    </page-body>
  </div>
</template>

<script>
import AnalysisAlarmList from './components/List'

export default {
  name: 'AnalysisAlarmIndex',
  components: {
    AnalysisAlarmList,
  },
  data () {
    return {}
  },
}
</script>
